import { ref } from 'vue'
import { defineStore } from 'pinia'
import { cloneDeep } from 'lodash'
import { filterApi } from '../api/filter.api'
import { useClientStore } from '@/modules/client/stores/client.store'
import { useQueryStore } from '@/shared/stores/query-param.store'
import { useBrandStore } from '@/modules/brand/stores/brand.store'
import { ClientSetting } from '@/modules/client/types/client.enums'
import { DEFAULT_FILTER_QUERY } from '../constants/filter.constants'
import type { UserFilter } from '../models/filter.model'
import type { FilterQuery } from '@/shared/models/filter-query.model'

export const useFilterStore = defineStore('filter', () => {
  const clientStore = useClientStore()
  const queryStore = useQueryStore()
  const brandStore = useBrandStore()
  const filter = ref<FilterQuery>(cloneDeep(DEFAULT_FILTER_QUERY))

  const setDefaultFilter = (): void => {
    filter.value = cloneDeep(DEFAULT_FILTER_QUERY)
  }

  const setFilter = (data: UserFilter): void => {
    filter.value.fromViewDate = data.fromViewDate
    filter.value.toViewDate = data.toViewDate
    filter.value.fromActionDate = data.fromActionDate
    filter.value.toActionDate = data.toActionDate
    filter.value.carrierId = data.carrierId
    filter.value.countryId = data.countryId
    filter.value.serviceGroupId = data.serviceGroupId
    filter.value.zipZoneId = data.zipZoneId
    filter.value.dimensions = data.dimensions
    filter.value.isUserRelated = clientStore.isSettingEnabled(ClientSetting.MyShipmentValue)
    filter.value.status = data.status || []
  }

  const loadFilterSelection = async (): Promise<boolean> => {
    setDefaultFilter()
    const response = await filterApi.getFilterSelection()
    if (!response.error && response.data) {
      setFilter(response.data.filter)
      brandStore.apply(response.data.brand)
      queryStore.apply()
      return true
    }
    return false
  }

  return {
    filter,
    loadFilterSelection,
  }
})
